<template>
  <div>
    <vue-toastr ref="hightlightToast"></vue-toastr>
    <div class="ibox box-primary">
      <div class="ibox-title with-border"><h3 class="box-title">Themenmedien</h3></div>
      <div class="ibox-content">
        <div class="form-group">
          <label for="title" class="control-label required">Content</label>
          <multiselect v-model="topic" :options="media" label="title" track-by="title"
                       placeholder="Content hinzufügen" :allow-empty="false" @select="selectContent"
                       :clear-on-select="true" openDirection="bottom"></multiselect>
        </div>

        <div>
          <vue-toastr ref="hightlightToast"></vue-toastr>
          <table class="table table-hover">
            <thead>
            <tr>
              <th></th>
              <th>Medientitel</th>
              <th></th>
            </tr>
            </thead>
            <draggable v-model="mediaOfTopic" group="media" @start="drag=true" @end="reorder" tag="tbody">
              <tr v-for="(item, index) in mediaOfTopic" :key="mediaOfTopic.id">
                <td style="width: 25px;cursor: grab"><i class="fa fa-bars" aria-hidden="true"></i></td>
                <td>{{ item.fmu_media.title }}</td>
                <td style="width: 25px;cursor:pointer"><i class="fa fa-trash" aria-hidden="true" @click="deleteMediaTopic(index, item.id)"></i></td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import draggable from 'vuedraggable'
import VueToastr from "vue-toastr";

export default {
  name: 'BmTopicWorlds',
  props: ['media', 'topicMedia', 'bmTopicWorldId'],
  components: {
    Multiselect,
    draggable,
    VueToastr
  },
  data() {
    return {
      topic: null,
      mediaOfTopic: {}
    }
  },
  mounted() {
    this.mediaOfTopic = this.topicMedia;
  },
  methods: {
    selectContent(media) {
      axios.post('/backend/bm_topic_worlds/insert-topics-world-media', {
        bm_topic_world_id: this.bmTopicWorldId,
        fmu_media_id: media.id
      }).then(res => {
        this.mediaOfTopic.push({
          id: res.data.id,
          position: res.data.position,
          fmu_media: {
            title: media.title
          }
        })
      })
    },
    reorder() {
      axios.post('/backend/bm_topic_worlds_media/reorder', {
        media: this.mediaOfTopic
      }).then(() => {
        this.$refs.hightlightToast.s("Neue Sortierung gespeichert", "Erfolgreich");
      }).catch(() => {
        this.$refs.hightlightToast.e("Bitte versuche es noch einmal.", "Fehler");
      })
    },
    deleteMediaTopic(index, id) {
      axios.delete(`/backend/bm_topic_worlds_media/${id}`).then(() => {
        this.mediaOfTopic.splice(index,1);
      })
    }
  }
}
</script>

<style scoped>
</style>
